// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RealtorReferralTableRecord_wrapper__345PV","wrapper__header":"RealtorReferralTableRecord_wrapper__header__2uhLQ"};